module.exports = __webpack_public_path__ + "img/库尔_迪拜.45073cde.webp";